import React from 'react'
import styled from 'styled-components'
import travelIcon from '../images/categories/travel.png'
import investmentsIcon from '../images/categories/business.png'
import diningIcon from '../images/categories/dining.png'
import incomeIcon from '../images/categories/income.png'
import entertainmentIcon from '../images/categories/entertainment.png'
import retailIcon from '../images/categories/retail.png'
import educationIcon from '../images/categories/education.png'

const Wrapper = styled.div`
    display: flex;
    text-transform: capitalize;
    align-items: flex-start;
    padding: 16px 0;
    border-bottom: 0.5px solid #E4E7E7;
    font-size: 14px;
    color: #959D9D;
    font-weight: 400;
    justify-content: space-between;

    p {
        margin: 0;
    }

    img {
        width: 18px;
        height: 18px;
        margin-right: 12px;
    }
`

const Inner = styled.div`
    display: flex;
`
const T = styled.p`
    color: #081717;
`
const V = styled.p`
    font-family: "SFMono-Regular", Consolas, "Liberation Mono", Menlo, Courier, monospace;
    color: ${(props) => props.amount > 0 ? '#008060' : '#081717'};
`

const Transaction = ({amount, merchant, date, category}) => {
    const renderCatergory = (category) => {
        switch (category) {
            case 'RESTAURANTS_DINING':
                return diningIcon
            case 'TRAVEL':
                return travelIcon
            case 'SALARY_REVENUE':
                return incomeIcon
            case 'ENTERTAINMENT':
                    return entertainmentIcon
            case 'RETAIL':
                return retailIcon
            case 'EDUCATION':
                return educationIcon        
            default:
                return investmentsIcon
        }
    }

    return (
        <Wrapper>
            <Inner>
                <img src={renderCatergory(category)} alt={category} />
                <div>
                    <T>{merchant.toLowerCase()}</T>
                    <p>{date}</p>
                </div>
            </Inner>
            <V amount={amount}>{amount.toLocaleString()}</V>
        </Wrapper>
    )
}

export default Transaction